<div class="container">
  <mat-tab-group selectedIndex="2" style="margin-left: 100px; margin-right: 100px; margin-top: 50px">
    <mat-tab [label]="surveyConfig.previousYear.toString()">
      <ng-template matTabContent>
        <app-users-panel [surveyId]="surveyConfig.previousYearSurveyId"></app-users-panel>
      </ng-template>
    </mat-tab>
    <mat-tab [label]="surveyConfig.currentYear.toString()">
      <ng-template matTabContent>
        <app-users-panel [surveyId]="surveyConfig.currentYearSurveyId"></app-users-panel>
      </ng-template>
    </mat-tab>

  </mat-tab-group>
</div>
